import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, effect, HostListener, inject, input, OnDestroy, OnInit, output, signal } from '@angular/core';
import { WistiaService } from '../../../services/wistia/wistia.service';
import { toObservable } from '@angular/core/rxjs-interop';
import { take } from 'rxjs';

interface WistiaVideo { wistiaId: string, furthestWatchedSecond?: number, completedUTC?: number }

@Component({
	selector: 'common-wistia-player',
	standalone: true,
	template: `
		<div class="wistia-container">
			<div class="wistia_responsive_padding">
				<div id="wistia_player" class="wistia_embed wistia_async_{{video().wistiaId}}" style="height:100%;width:100%">&nbsp;</div>
			</div>
		</div>
	`,
	styles: `
		.wistia-container {
			width: 100%;
			max-width: 1200px; /* Example max width */
			margin: 0 auto; /* Center the container */
		}

		.wistia_responsive_padding {
			position: relative;
			padding-bottom: 56.25%; /* 16:9 aspect ratio */
			height: 0;
			overflow: hidden;
		}

		.wistia_responsive_padding .wistia_embed {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	`,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommonWistiaPlayerWidget implements AfterViewInit, OnDestroy {
	public wistiaService = inject(WistiaService);

	public readonly video = input.required<WistiaVideo>();
	public readonly videoWatchedVectorChanged = output<number[]>();
	private currentWistiaId = signal<string | undefined>(undefined); // Signal to hold the current Wistia ID
	private videoData: WistiaVideo | undefined = undefined;

	constructor() {

		toObservable(this.video).pipe(take(1)).subscribe(async (video) => {
			if (video && video.wistiaId !== this.currentWistiaId()) {
				await this.loadVideo(video);
				this.videoData = video;
			}
		});

		toObservable(this.wistiaService.secondsWatchedVector).subscribe((vector) => {
			if (this.videoData && vector && this.videoData.wistiaId === this.currentWistiaId() && this.wistiaService.isPlaying()) {
				this.videoWatchedVectorChanged.emit(vector);
			}
		});

	}



	async ngAfterViewInit() {
		await this.wistiaService.onNgAfterViewInit();
	}

	async ngOnDestroy() {
		await this.wistiaService.onNgOnDestroy();
	}


	async loadVideo(video: { wistiaId: string, furthestWatchedSecond?: number, completedUTC?: number }) {

		try {

			await this.wistiaService.replaceVideo(video.wistiaId, false);
			this.currentWistiaId.set(video.wistiaId);


			if (video.furthestWatchedSecond && !video.completedUTC) {
				await this.wistiaService.seekVideo(video.furthestWatchedSecond);
			}

			// await this.wistiaService.setWidth(396);

		} catch (error) {
			console.error("Error loading video:", error); // Handle errors!
		}
	}


	@HostListener('window:orientationchange', ['$event'])
	onOrientationChange() {
		if (window.screen.orientation.type.startsWith('portrait')) {
			// Handle portrait orientation
			this.wistiaService.cancelFullscreen();
		} else {
			// Handle landscape orientation
			this.wistiaService.requestFullscreen();
		}
	}


}